/**
 * This file takes care of global app side effects,
 * like clicking on add to cart and the cart modal being displayed
 */

import { signal } from '@preact/signals'

const tagKitDiscount = signal(0)

const state = {
	tagKitDiscount,
}

export const kitPdpDabelleUI = () => state
